export default {
  methods: {
    formatNumber: function (value, lang = 'sr', fraction = 2) {
      let numberForFormat = 0
      if (value) {
        numberForFormat = value
      }
      return numberForFormat.toLocaleString(lang, {
        minimumFractionDigits: fraction,
        maximumFractionDigits: fraction
      })
    }
  }
}
